import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import RateMealMutation from './RateMealMutation';

const RateMealConnectorApollo = ({ children }) => {
  const [rateMeal] = useMutation(RateMealMutation);

  const createRateMeal = async (request) => {
    const { mealId, rating, labels } = request;
    const response = await rateMeal({
      variables: { mealId, rating, labels },
    });

    return response;
  };

  return children({
    rateMeal: createRateMeal,
  });
};

RateMealConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default RateMealConnectorApollo;
